import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EventAreaItemSlot } from '../../models/event-area-item-slot';
import { LocalizationService } from '../../../../services/localization.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-booking-event-area-item-slot',
  templateUrl: './booking-event-area-item-slot.component.html',
  styleUrls: ['./booking-event-area-item-slot.component.css']
})
export class BookingEventAreaItemSlotComponent implements OnInit {

  @Input()
  eventAreaItemSlot: EventAreaItemSlot;

  @Input()
  maxLenNameSlot = 0;

  @Input()
  quantityLetterInSlot = 0;

  @Output()
  eventAreaItemSelected: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private localizationService: LocalizationService,
  ) { }

  ngOnInit() {
  }

  get title(): string {
    return this.eventAreaItemSlot && this.eventAreaItemSlot.name ? this.eventAreaItemSlot.name : '';
  }

  get date(): string {
    let date = '';
    if (this.eventAreaItemSlot && this.eventAreaItemSlot.bookingSlot && this.eventAreaItemSlot.bookingSlot.bookingDate) {
      date = this.localizationService.formatDate(this.eventAreaItemSlot.bookingSlot.bookingDate);
    }
    return date;
  }

  get slotTime(): string {
    let slotTime = '';
    if (this.eventAreaItemSlot && this.eventAreaItemSlot.bookingSlot && this.eventAreaItemSlot.bookingSlot.fromTime) {
      let toTime = this.eventAreaItemSlot.bookingSlot.toTime;

      if (this.eventAreaItemSlot.areaItem && this.eventAreaItemSlot.areaItem.minutes) {
        toTime = this.eventAreaItemSlot.bookingSlot.fromTime + environment.globalSettings.minutesToFloat(this.eventAreaItemSlot.areaItem.minutes);
      }

      if (toTime >= 24) {
        toTime = toTime - 24 * Math.round(toTime / 24);
      }

      slotTime = environment.globalSettings.toTimeString(this.eventAreaItemSlot.bookingSlot.fromTime) + ' - ' + environment.globalSettings.toTimeString(toTime);
    }

    return slotTime;
  }

  get amount(): string {
    if (this.eventAreaItemSlot && this.eventAreaItemSlot.areaItem && this.eventAreaItemSlot.areaItem.price) {
      return environment.globalSettings.toMoneyStr(this.eventAreaItemSlot.areaItem.price);
    }
    return '';
  }

  onClick() {
    this.eventAreaItemSelected.emit(this.eventAreaItemSlot);
  }

  get fontSizeClass(): string {
    return this.maxLenNameSlot > 12 || this.quantityLetterInSlot > 16 ? 'fontSizeTitle' : '';
  }

  get freeQuantity(): number {
    return this.eventAreaItemSlot
      && this.eventAreaItemSlot.bookingSlot
      && this.eventAreaItemSlot.bookingSlot.freeQuantity > 0 ? this.eventAreaItemSlot.bookingSlot.freeQuantity : 0;
  }
}
